import React from 'react';
import { connect } from 'react-redux';
import * as actionCreators from '../action_creators';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import { Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import UploadItem from './UploadItem';
import ButtonAction from './ButtonAction';
import ImageProcessingForm from './ImageProcessingForm';
import HelpPopover from './HelpPopover';
import LoadingModal from './LoadingModal';
import ScribeNotification from './ScribeNotification';
import RejectedFilesAlert from './RejectedFilesAlert';
import { isUploadable, isImage } from '../helpers/FileHelpers';
import { matchesSimpleString } from '../helpers/Validations';
import { toJS } from '../helpers/toJS';

export class Uploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: this.props.loading,
      loadingMessage: this.props.loadingMessage,
      hasImages: false,
      processImages: true,
      coverModal: false,
      files: [],
      cover: null,
      badNames: [],
      rejected: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading !== this.state.loading) {
      this.setState({
        loading: nextProps.loading,
        loadingMessage: nextProps.loadingMessage,
      });
    }
  }

  canSetCover() {
    return this.props.canSetCover === undefined ? true : this.props.canSetCover;
  }

  fileAlreadyLoaded(file) {
    const match = _.find(this.state.files, f => f.name === file.name);
    return !!match;
  }

  limitReached() {
    return this.state.files.length >= 100;
  }

  onDrop = (files) => {
    const uploadable = this.state.files.slice();
    const rejected = this.state.rejected.slice();
    files.map((file) => {
      const exists = this.fileAlreadyLoaded(file);
      if (this.limitReached()) {
        // do nothing
      } else if (isUploadable(file) && !exists) {
        this.checkName(file.name);
        uploadable.push(file);
        this.setImageStatus(file);
      } else if (exists) {
        // ignore it
      } else {
        rejected.push(file);
      }
    });
    this.setState({
      files: uploadable,
      rejected,
    });
  }

  checkName = (name) => {
    const badNames = this.state.badNames;
    if (!matchesSimpleString(name)) {
      badNames.push(name);
    }
  }

  setImageStatus = (file) => {
    file.isImage = isImage(file);
    file.imageSettings = { process: true };
    if (file.isImage) {
      if (/-cover\.[a-zA-Z0-9]+$/.test(file.name) && this.canSetCover()){
        file.imageSettings.height = 1800;
        file.imageSettings.width = 1800;
        this.setState({ hasImages: true, cover: file.name });
      }
      else {
        this.setState({ hasImages: true });
      }
    }
  }

  checkForImage = () => {
    const image = _.find(this.state.files, f => isImage(f));
    this.setState({ hasImages: !!image });
  }

  // needs to change hasImages
  removeFile = (index) => {
    const files = this.state.files;
    files.splice(index, 1);
    this.setState({ files });
    this.checkForImage();
  }

  toggleImageProcessing = (e) => {
    e.preventDefault();
    this.setState({ processImages: !this.state.processImages });
  }

  badNamesAlert() {
    return (<div className="uploader-alert alert alert-dismissible fade show" role="alert">
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      <p>
        <strong>Warning!</strong> One or more files have names containing
        characters that can be problematic in ebook development.
      </p>
      <p>
        Names should contain only upper and lower case letters, numbers,
        periods, hyphens, and underscores. You can proceed with the current
        names, but it is recommended that you adjust them.
      </p>
      <p>
        These files are highlighted in yellow below.
      </p>
    </div>);
  }

  limitReachedAlert() {
    return (<div className="uploader-alert alert alert-dismissible fade show" role="alert">
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      <p>
        <strong>Warning!</strong> The Hub only accepts 100 files at a time. You can upload the 100 files attached here and then upload more.
      </p>
    </div>);
  }

  submitFiles = (e) => {
    e.preventDefault();
    var globalImageDimensions = {}; // or just {}
    if (!!this.refs.globalImageSettings){
      globalImageDimensions['image_settings'] = true;
      globalImageDimensions['width'] = this.refs.globalImageSettings.state.width;
      globalImageDimensions['height'] = this.refs.globalImageSettings.state.height;
      globalImageDimensions['format'] = this.refs.globalImageSettings.state.format;
    } else {
      globalImageDimensions['image_settings'] = false;
    }
    if (this.props.forOrg) {
      this.props.createFiles(this.props.id, this.state.files, this, globalImageDimensions);
    } else {
      this.props.createFiles(this.props.id, this.state.files, this.state.cover, globalImageDimensions);
    }
  }

  upload = (e) => {
    e.preventDefault();

    if (
      this.canSetCover() &&
      this.state.hasImages &&
      !this.state.cover &&
      !this.props.projectHasCover
    ) {
      this.toggleCoverModal();
    } else {
      this.submitFiles(e);
    }
  }

  confirmedUpload = (e) => {
    e.preventDefault();
    this.setState({ coverModal: false });
    this.submitFiles(e);
  }

  changeCover = (name) => {
    let newCover;
    if (name !== this.state.cover) {
      newCover = name;
    }
    this.setState({ cover: newCover });
  }

  toggleCoverModal = () => {
    this.setState({ coverModal: !this.state.coverModal });
  }

  hasError() {
    return !!this.props.error;
  }

  render() {
    return (<Container className="project-uploader">
      <ScribeNotification
        error
        isActive={this.hasError()}
        message={this.props.error || ''}
        action={'close'}
        onClick={this.props.clearError}
        activeBarStyle={{ zIndex: 10000 }}
      />
      <LoadingModal
        modalOpen={this.state.loading}
        header={this.state.loadingMessage}
        closeModal={() => true}
        percent={this.props.percentDone || 0}
        progress={!this.props.forOrg}
      />
      <Modal
        isOpen={this.state.coverModal}
        toggle={this.toggleCoverModal}
        key="no-cover-modal"
        className="modal-warning"
      >
        <div className="modal-header">
          <h3 className="modal-header-title">No Cover Specified</h3>
        </div>
        <ModalBody>
            You are uploading images but have not specified a cover.
            To continue without a cover, click "Upload Anyway."
            To specify one of the attached images as the cover, click "Cancel" and use the "Set cover" button for the correct image.
          </ModalBody>
        <ModalFooter>
          <Container>
            <Row>
              <Col xs="6">
                <Button
                  color="warning"
                  onClick={this.confirmedUpload}
                  className="float-md-start"
                >
                    Upload Anyway
                  </Button>
              </Col>
              <Col xs="6">
                <Button
                  color="success"
                  onClick={this.toggleCoverModal}
                >
                    Cancel
                  </Button>
              </Col>
            </Row>
          </Container>
        </ModalFooter>
      </Modal>
      <Row>
        <Col md={6}>
          <Dropzone
            style={{}}
            className="uploader-dropzone"
            ref="dropzone"
            onDrop={this.onDrop}
            inputProps={{ name: 'uploader-input', id: 'uploader-input' }}
          >
            <p className="uploader-text">
              <i className="fa fa-upload" />
              <br />
                Upload your files here.
              </p>
          </Dropzone>
        </Col>
        <Col md={6}>
          <div className="upload-form-header">
            <h2>{this.state.files.length} files</h2>
            <ButtonGroup>
              <ButtonAction id="upload" color="success" action={this.upload} disabled={!(this.state.files.length > 0)}>
                  Upload Files
                </ButtonAction>
              {this.canSetCover() ?
                <Button href={`/wfdw/projects/${this.props.id}`} color="warning" title="Return to project without uploading">
                  Cancel Uploads
                </Button> : null}
            </ButtonGroup>
          </div>
          <RejectedFilesAlert files={this.state.rejected} />
          {this.state.badNames.length > 0 ? this.badNamesAlert() : null }
          {this.limitReached() ? this.limitReachedAlert() : null }
          {this.state.hasImages ? <ImageProcessingForm
            className="uploader-images-main"
            enabled={this.state.processImages}
            ref="globalImageSettings"
          >
            <FormGroup row>
              <Col sm={6}>
                <h3 className="h5">Global Image Settings</h3>
              </Col>
              <Col sm={6}>
                <FormGroup check className="float-md-end">
                  <HelpPopover
                    size="sm"
                    name="image-settings"
                    title="Hub Image Processing"
                  >
                      By default, images are processed as <strong>JPEGs</strong> with a maximum width and height of <strong>600 pixels</strong>.<br />
                      An image marked as the cover is processed with a maximum width and height of <strong>1800 pixels</strong>.<br />
                      Image settings can be turned off or changed for all images in this Global Image Settings panel.<br />
                      The settings panel for an individual image can be opened by clicking the gear icon for that image. Here, the settings for that image can be modified or processing can be turned off.
                    </HelpPopover>{' '}
                  <Label check>
                    <ButtonAction
                      size="sm"
                      icon={this.state.processImages ? 'fa-check' : 'fa-remove'}
                      color={this.state.processImages ? 'success' : 'warning'}
                      action={this.toggleImageProcessing}
                    >
                        Process Images
                      </ButtonAction>
                  </Label>
                </FormGroup>
              </Col>
            </FormGroup>
          </ImageProcessingForm> : null }
          {this.state.files.length > 0 ?
            <ul className="list-group">
              {this.state.files.map((file, index) =>
                  (<UploadItem
                    key={index}
                    file={file}
                    removeFile={() => this.removeFile(index)}
                    processImages={this.state.processImages}
                    cover={file.name === this.state.cover}
                    canSetCover={this.canSetCover()}
                    changeCover={this.changeCover}
                  />),
                )}
            </ul> : null}
        </Col>
      </Row>
    </Container>);
  }
}

function mapStateToProps(state) {
  return {
    id: state.get('id'),
    loading: state.get('loading'),
    loadingMessage: state.get('loadingMessage'),
    projectHasCover: state.get('cover'),
    percentDone: state.get('percentDone'),
    error: state.get('error'),
  };
}

export const UploaderContainer = connect(
    mapStateToProps,
    actionCreators,
)(toJS(Uploader));
